import * as React from 'react';
import { css, SerializedStyles } from '@emotion/core';
import { useWindowSize } from '../core/hooks/useWindowSize';
import { useBrowser } from '../language/useBrowser';
import { motion } from 'framer-motion';
import LocalDiv from '../localization/LocalDiv';
import { PAGE_BG, PAGE_HEIGHT, PAGE_PADDING } from './pageStyle';
import SideMenu from '../navigation/SideMenu';


const styles = {
  root:        css`
    display: flex;
    flex-direction: row;
  `,
  pageContent: css`
    flex-grow: 1;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  `,
};


type Props = {
  children: React.ReactNode;
  floatMenu?: boolean;
  className?: string;
  contentStyle?: SerializedStyles;
  menu: React.ReactNode;
};


/**
 * DashboardLayout: a component that renders content with standard portal dash padding/margins and a slide-out side
 * menu.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const DashboardLayout: React.FC<Props> = props => {
  const { isMobile } = useWindowSize();
  const { onIe }     = useBrowser();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <LocalDiv css={[PAGE_BG, PAGE_HEIGHT, styles.root]} className={props.className}>
        <SideMenu
          contentWidthPx={240}
          displace={!isMobile && !props.floatMenu}
          startOpen={!isMobile}
          closeOnClickInside={isMobile}
        >
          {props.menu}
        </SideMenu>
        <div
          css={[
            PAGE_PADDING,
            styles.pageContent,
            onIe ? css`width: 100%;` : undefined,
            props.contentStyle,
          ]}
        >
          {props.children}
        </div>
      </LocalDiv>
    </motion.div>
  );
};

export default DashboardLayout;
